var path = 'components/errorMessages.html';
var html = "<div ng-message=required translate>This field is required.</div> <div ng-message=minlength translate>Your field is too short</div> <div ng-message=maxlength translate>Your field is too long</div> <div ng-message=email translate>You must supply a valid email address.</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/errorMessages.html
// module id = 188
// module chunks = 1